import { Typography } from '@material-ui/core'
import { attributes, memberOf } from '@type-r/models'
import { useIO, useModel } from "@type-r/react"
import { asCurrency, asTimelessDate, Flex, Page, PageHeaderTile, PageTileField, SmallTile, TilesList } from 'lqx-react'
import * as React from 'react'
import { Payment } from '../../api/payment'
import { Source } from '../../api/source'
import { PaymentDetails } from './details'

const State = attributes({
    source : Source,
    payments : [ Payment ],
    selected : memberOf( 'payments', Payment )
})

export const ResolvePaymentsPage = ({ sourceId }) =>{
    const state = useModel( State );

    const isReady = useIO( async () => {
        state.source = { id : sourceId, name : 'Citi' } as any;
        state.payments = [ { creditorBankAccount : { name : 'Bosh'}}, { creditorBankAccount : { name : 'Compaq' }} ] as any;
        // await state.source.fetch();
    });

    const filtered = state.payments.models;

    return (
        <Page
            top={
                <PageHeaderTile
                    color={'red'}
                    title={ state.source.name }
                    returnLink="/digitization/resolve"
                    right={'right'}
                >
                    <PageTileField label="Unresolved">{666}</PageTileField>
                </PageHeaderTile>
            }

            menuWidth={400}
            left={
                <>
                    {filtered.length ? (
                        <TilesList
                            items={filtered}
                            itemSize={64}
                            renderer={PaymentTile(state.$.selected)}
                            selectedItem={state.selected}
                        />
                    ) : (
                        <Flex center stretch>
                           <Typography variant="h4">No results found.</Typography>
                        </Flex>
                    )}
                    </>
            }
        >
            { state.selected ?
                <PaymentDetails payment={ state.selected }/>
            :
                <Flex center stretch>
                    <Typography variant="h4">Select a payment</Typography>
                </Flex>
            }
        </Page>
    )
}

const PaymentTile = $selected => ({ data, style, index }) => {
    const payment: Payment = data.items[index];

    console.log( 'PT' );

    return (
      <div style={style}>
        <SmallTile
          color={'green'}
          isSelected={$selected.value === payment}
          onClick={e => {
            $selected.set(payment);
          }}
          footer={
            <>
              <div>{payment.creditorBankAccount.name}</div>
              <Flex grow />
            </>
          }
        >
          {asCurrency(payment.paymentAmount)}
          <Flex grow />
          {/* {payment. > 2 ? <SmallChip>{payment.age} days</SmallChip> : null} */}
          {asTimelessDate(payment.assetPaymentDate)}
        </SmallTile>
      </div>
    );
  };
